/**
 * Les parties du quiz élève qui ont un TEXTE à lire (11/10/2026) : la compréhension de l'écrit, que le texte
 * soit celui de septembre, celui d'une variante ou celui d'une forme parallèle. À l'entrée d'une telle partie,
 * le quiz ouvre le livre une fois (la consigne du ministère : lire le texte en entier avant de répondre).
 */
import { TEXTES_COMPREHENSION, nomDuTexte } from '../../components/VueEvalNat/EvalNat/evaluationConfig';
import { supportDeQuestion } from '../../generators/evalnat/supports';

const PREFIXE = "Compréhension de l'écrit";

/** La partie de cette question a-t-elle un texte ? Le sien (variante, forme parallèle), ou celui de septembre. */
export const partieAvecTexte = (question, partie) => Boolean(question)
    && (Boolean(supportDeQuestion(question)) || TEXTES_COMPREHENSION.some((t) => t.typeLabel === partie));

/** Le nom d'une partie annoncé à l'élève : « Compréhension de l'écrit : « Les Fées » » plutôt que le libellé brut. */
export const libellePartie = (partie) => {
    const nom = String(partie || '');
    if (!nom.replace(/’/g, "'").startsWith(PREFIXE)) return nom;
    return `${PREFIXE} : « ${nomDuTexte(nom.replace(/’/g, "'"))} »`;
};
